import { Login } from "@/Features/Shared/Login";
import {
    faBookOpenReader,
    faBullhorn,
    faChartSimple,
    faFileInvoiceDollar,
    faScaleBalanced,
    faTableCells,
    faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, NavLink } from "react-router-dom";
import { ROUTES } from "@routing/routes";
import { PendingClientsBadge } from "./_components/PendingClientsBadge";
import { ReceivedOrdersBadge } from "./_components/ReceivedOrdersBadge";

export const AdminHeader = () => {
    const defaultClass = "px-2";
    return (
        <div className="shadow-sm text-teal-50 bg-secondary">
            <header className="navbar max-w-5xl mx-auto h-10">
                <div className="navbar-start">
                    <Link
                        to="/a"
                        className="text-3xl py-0 uppercase text-warning"
                    >
                        NARA Admin
                    </Link>
                </div>
                <div className="navbar-center">
                    <ul className="menu menu-horizontal px-1 text-xl">
                        <li className={defaultClass}>
                            <NavLink
                                to="/a/dashboard"
                                className={({ isActive }) =>
                                    isActive ? "bg-primary" : ""
                                }
                            >
                                <FontAwesomeIcon icon={faChartSimple} />
                                Dashboard
                            </NavLink>
                        </li>
                        <li className={defaultClass}>
                            <NavLink
                                to="/a/inventory"
                                className={({ isActive }) =>
                                    isActive ? "bg-primary" : ""
                                }
                            >
                                <FontAwesomeIcon icon={faBookOpenReader} />
                                Inventory
                            </NavLink>
                        </li>
                        <li className={defaultClass}>
                            <NavLink
                                to="/a/orders"
                                className={({ isActive }) =>
                                    isActive ? "bg-primary" : ""
                                }
                            >
                                <FontAwesomeIcon icon={faTableCells} /> Orders
                                <ReceivedOrdersBadge />
                            </NavLink>
                        </li>
                        <li className={defaultClass}>
                            <NavLink
                                to={ROUTES.ADMIN_CLIENTS}
                                className={({ isActive }) =>
                                    isActive ? "bg-primary" : ""
                                }
                            >
                                <FontAwesomeIcon icon={faUser} /> Clients
                                <PendingClientsBadge />
                            </NavLink>
                        </li>
                        <li className={defaultClass}>
                            <NavLink
                                to={ROUTES.ADMIN_LEGAL_CLASSES}
                                className={({ isActive }) =>
                                    isActive ? "bg-primary" : ""
                                }
                            >
                                <FontAwesomeIcon icon={faScaleBalanced} />
                                Legal
                            </NavLink>
                        </li>
                        <li className={defaultClass}>
                            <NavLink
                                to={ROUTES.ADMIN_PROMOTIONS}
                                className={({ isActive }) =>
                                    isActive ? "bg-primary" : ""
                                }
                            >
                                {/* FontAwesome to match this legacy header's
                                    siblings, as Billing below. */}
                                <FontAwesomeIcon icon={faBullhorn} />
                                Promotions
                            </NavLink>
                        </li>
                        <li className={defaultClass}>
                            <NavLink
                                to={ROUTES.ADMIN_UNCONFIRMED_CHARGES}
                                className={({ isActive }) =>
                                    isActive ? "bg-primary" : ""
                                }
                            >
                                {/* FontAwesome to match this legacy header's
                                    siblings (a lone Material icon here would
                                    clash); new surfaces use @common/Icon. */}
                                <FontAwesomeIcon icon={faFileInvoiceDollar} />
                                Billing
                            </NavLink>
                        </li>
                    </ul>
                </div>
                <div className="navbar-end">
                    <Login />
                </div>
            </header>
        </div>
    );
};
